import client from './client';

export const notificationsApi = {
  // Legacy
  list: (params) => client.get('/notifications', { params }),
  unreadCount: () => client.get('/notifications/unread-count'),
  markRead: (id) => client.put(`/notifications/${id}/read`),
  markAllRead: () => client.put('/notifications/read-all'),
  remove: (id) => client.delete(`/notifications/${id}`),

  // Inbox
  listWithFilters: (filters = {}) =>
    client.get('/notifications', { params: filters }),

  updateStatus: (id, status) =>
    client.put(`/notifications/${id}/status`, { status }),

  bulkUpdateStatus: (ids, status) =>
    client.put('/notifications/bulk/status', { ids, status }),

  /**
   * SSE-URL (Token als Query-Param, falls backend das akzeptiert — sonst EventSource
   * via Fetch-Stream). Hier: wir geben die volle URL zurueck; der useInboxSSE-Hook
   * nutzt EventSource mit Credentials. Bei Bedarf auf fetch-Stream umstellen.
   */
  streamUrl: () => {
    const base = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';
    const token = localStorage.getItem('accessToken') || '';
    // EventSource kann keine Header senden — Token via Query-Param
    const sep = base.includes('?') ? '&' : '?';
    return `${base}/notifications/inbox/stream${token ? `${sep}token=${encodeURIComponent(token)}` : ''}`;
  }
};
